<div class="composer">
  @if (!composition.length) {
    <div class="left-pane-logo">
      <img src="assets/img/logo.svg" class="logo-img-3d" [alt]="'components.composer.composer.visionnaire' | translate"/>
    </div>
  } @else {
    <div class="left-pane"  (wheel)="onWheel($event)">
      <div class="button-bar" [hidden]="!composition.length">
        <button class="step-button btn"
                id="editButton"
                type="button"
                [title]="'composition.edit' | translate"
                [class.is-disabled]="tabIndex === 0"
                (click)="goToTab(0)"
        >
          <svg fill="#000" width="22px" height="22px"
               id="Layer_1"
               xmlns="http://www.w3.org/2000/svg"
               x="0px" y="0px" viewBox="0 0 24 24">
            <g>
              <g>
                <g>
                  <path
                    d="m23.911 23.229 -16.163 -23.02A0.49 0.49 0 0 0 6.857 0.49v6.367h2.449v0.98h-2.449v2.449h2.449v0.98h-2.449v2.449h2.449v0.98h-2.449v2.449h2.449v0.98h-2.449v2.449h2.449v0.98h-2.449v1.959c0 0.271 0.219 0.49 0.49 0.49h16.163a0.49 0.49 0 0 0 0.401 -0.771m-6.967 -3.908A0.49 0.49 0 0 1 16.506 19.592H11.363c-0.271 0 -0.49 -0.219 -0.49 -0.49V12.245a0.49 0.49 0 0 1 0.882 -0.294l5.143 6.857a0.49 0.49 0 0 1 0.046 0.513"/>
                  <path
                    d="M5.388 0H0.49C0.219 0 0 0.219 0 0.49v2.694h2.585v0.98H0v2.939h2.585v0.98H0v3.429h2.585v0.98H0v3.429h2.585v0.98H0v2.939h2.585v0.98H0v2.694c0 0.271 0.219 0.49 0.49 0.49h4.898c0.271 0 0.49 -0.219 0.49 -0.49V0.49c0 -0.271 -0.219 -0.49 -0.49 -0.49"/>
                </g>
              </g>
            </g>
          </svg>

        </button>
        <button class="btn step-button"
                id="3DButton"
                type="button"
                [title]="'3D'"

                [class.is-disabled]="tabIndex === 1"
                (click)="goToTab(1)"
        >
          <svg fill="#000" width="24px" height="24px"
               viewBox="0 0 1024 1024"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M838.4 325.12 554.24 479.36C528 493.44 512 521.6 512 552.96l0 298.24c0 32 31.36 53.12 57.6 38.4l284.16-154.24c25.6-14.08 42.24-42.24 42.24-73.6L896 364.16C896 331.52 864.64 311.04 838.4 325.12zM405.76 478.72 121.6 325.12C95.36 311.04 64 331.52 64 363.52l0 299.52c0 31.36 16 59.52 42.24 73.6l284.16 153.6C416.64 904.32 448 883.2 448 851.2L448 552.32C448 520.96 432 492.8 405.76 478.72zM812.16 255.36c13.44-7.04 19.84-19.2 18.56-30.72 1.28-12.16-5.12-23.68-18.56-30.72L522.88 42.88c-12.8-7.04-28.16-10.24-43.52-10.24-15.36 0-30.72 3.2-43.52 10.24L146.56 193.28C133.12 200.32 127.36 212.48 128 224 127.36 236.16 133.12 248.32 146.56 255.36l289.28 150.4c12.8 7.04 28.16 10.24 43.52 10.24 15.36 0 30.72-3.2 43.52-10.24L812.16 255.36z"/>
          </svg>

        </button>
        <button class="btn"
                id="deleteButton"
                type="button"
                [disabled]="!selectedElem"
                (click)="onDeleteSelected()"
        >
          <svg width="24px" height="24px" viewBox="-0.015 0 0.57 0.57" xmlns="http://www.w3.org/2000/svg"
          >
            <g id="out" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path
                d="M0.148 0.447c0 0.014 0.021 0.033 0.034 0.033h0.206c0.014 0 0.034 -0.019 0.034 -0.033V0.18H0.148zM0.45 0.104h-0.073L0.34 0.06H0.23L0.193 0.104H0.12V0.148h0.33z"
                id="path" fill="#000"/>
            </g>
          </svg>
        </button>
      </div>
      @if (tabIndex === 0) {
        <div class="zoom-content composition-wrapper" [style.transform]="transform">
          @if (loading) {
            <div class="loader-overlay">
              <div class="spinner"></div>
            </div>
          }
          <div id="composition" class="composition">
            @if (showLeftHook) {
              <div id="lHook" class="hook l-hook" (click)="onSelectHook('L')">
                @if (!isLeftHookSelected) {
                  <svg
                       class="bi"
                       xmlns="http://www.w3.org/2000/svg"
                       width="16"
                       height="16"
                       viewBox="0 0 34 34"
                       fill="none"
                  >
                    <circle cx="17" cy="17" r="17" fill="#EDE8E3"/>
                    <line x1="17" y1="10" x2="17" y2="24" stroke="darkgray" stroke-width="2" stroke-linecap="round"/>
                    <line x1="10" y1="17" x2="24" y2="17" stroke="darkgray" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                } @else {
                  <svg
                       class="bi"
                       xmlns="http://www.w3.org/2000/svg"
                       width="16"
                       height="16"
                       viewBox="0 0 34 34"
                       fill="none"
                  >
                    <circle cx="17" cy="17" r="17" fill="#000"/>
                    <line x1="17" y1="10" x2="17" y2="24" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    <line x1="10" y1="17" x2="24" y2="17" stroke="white" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                }
              </div>
            }
            @for (elem of composition; track elem) {
              <div
                   class="elem"
                   [class.z-elem-selected]="isSelectedElement(elem)"
                   [class.not-selectable]="!isElementSelectable(elem)"
                   (click)="isElementSelectable(elem) && onSelectElement(elem)"
              >
                @if (elem.model.img) {
                  <img src="{{elem.model.img}}" alt="{{elem.model.name}}"/>
                }
              </div>
            }
            <!-- elementi -->


            @if (showRightHook) {
              <div
                   id="rHook"
                   class="hook r-hook"
                   (click)="onSelectHook('R')">

                @if (!isRightHookSelected) {
                  <svg
                       class="bi"
                       xmlns="http://www.w3.org/2000/svg"
                       width="16"
                       height="16"
                       viewBox="0 0 34 34"
                       fill="none"
                  >
                    <circle cx="17" cy="17" r="17" fill="#EDE8E3"/>
                    <line x1="17" y1="10" x2="17" y2="24" stroke="darkgray" stroke-width="2" stroke-linecap="round"/>
                    <line x1="10" y1="17" x2="24" y2="17" stroke="darkgray" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                } @else {
                  <svg
                       class="bi"
                       xmlns="http://www.w3.org/2000/svg"
                       width="16"
                       height="16"
                       viewBox="0 0 34 34"
                       fill="none"
                  >
                    <circle cx="17" cy="17" r="17" fill="#000"/>
                    <line x1="17" y1="10" x2="17" y2="24" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    <line x1="10" y1="17" x2="24" y2="17" stroke="white" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                }
              </div>
            }
          </div>
        </div>
      }
      <div class="composition-wrapper vesta-size" [class.is-hidden]="tabIndex === 0">
        @if (vestaInput) {
          <app-vesta class="vesta-size" *ngIf="vestaInput" [vestaId]="walkerVestaExternalLink"></app-vesta>
        }
      </div>
    </div>
  }
  <div class="right-pane">
    <mat-tab-group [selectedIndex]="tabIndex" class="tab-container">
      @for (tab of tabs; track tab) {
        <mat-tab
                 class="tab flex-sb"
                 (change)="goToTab(tabIndex)"
                 [disabled]="preventTabChange(tab)"
                 [class.is-disabled]="preventTabChange(tab)"
        >
          <ng-template mat-tab-label>
            <span
              [matTooltip]=" 'composition.incomplete' | translate "
              matTooltipPosition="below"
              [matTooltipDisabled]="!preventTabChange(tab)"
            >
              {{ tab.label | translate }}
            </span>
          </ng-template>
          <ng-template matTabContent>
            <div class="tab-content pt-4">
              @switch (tab?.id) {
                @case ('elements') {
                  <h1>{{ 'components.composer.composer.walker' | translate }}</h1>
                  <p>{{ 'composition.elements-selection' | translate }}</p>
                  <div class="element-content">

                    <h2>{{ 'components.composer.composer.leftElements' | translate }}</h2>
                    <div id="leftCatalog" class="element-group">
                      @for (leftModel of leftCatalog; track leftModel) {
                        <div
                          class="element-card"
                          [class.is-disabled]="isRightHookSelected || fullChainReached"
                          (click)="onAddModel(leftModel)"
                        >
                        <span>
                          @if (added(leftModel)) {
                            <img src="assets/svg/check-circle.svg" alt="+"/>
                          }
                        </span>
                          <div class="product-code flex-sb">
                            <span>{{ leftModel.name }}</span> <span class="mr-sm-3">{{ quantity(leftModel) || '' }}</span>
                          </div>
                          <span class="product-dimensions text-left">{{ leftModel.dimensions }}</span>
                          <img
                            src="https://cdnew.visionnaire-home.com/{{leftModel.name.substring(0, 3)}}/{{leftModel.name}}.jpg"
                            alt="{{leftModel.name}}"/>
                          @if ((isRightHookSelected || fullChainReached) && !added(leftModel)) {
                            <div class="disabled-layer" aria-hidden="true"></div>
                          }
                        </div>
                      }
                    </div>

                    <h2>{{ 'components.composer.composer.centralElements' | translate }}</h2>
                    <div id="centralCatalog" class="element-group">
                      @for (centreModel of centralCatalog; track centreModel) {
                        <div
                             class="element-card"
                             [class.is-disabled]="fullChainReached"
                             (click)="onAddModel(centreModel)">
                          <span>
                          @if (added(centreModel)) {
                            <img src="assets/svg/check-circle.svg"
                                 alt="+"/>
                          }
                        </span>
                          <div class="product-code flex-sb">
                            <span>{{ centreModel.name }}</span> <span class="mr-sm-3">{{ quantity(centreModel) || '' }}</span>
                          </div>
                          <span class="product-dimensions text-left">{{ centreModel.dimensions }}</span>
                          <img
                            src="https://cdnew.visionnaire-home.com/{{centreModel.name.substring(0, 3)}}/{{centreModel.name}}.jpg"
                            alt="{{centreModel.name}}"/>
                          @if (fullChainReached && !added(centreModel)) {
                            <div class="disabled-layer" aria-hidden="true"></div>
                          }
                        </div>
                      }
                    </div>
                    <h2>{{ 'components.composer.composer.rightElements' | translate }}</h2>
                    <div id="rightCatalog" class="element-group">
                      @for (rightModel of rightCatalog; track rightModel) {
                        <div
                             class="element-card"
                             [class.is-disabled]="isLeftHookSelected || fullChainReached"
                             (click)="onAddModel(rightModel)">
                          <span>
                            @if (added(rightModel)) {
                              <img src="assets/svg/check-circle.svg" alt="+"/>
                            }
                          </span>
                          <div class="product-code flex-sb">
                            <span>{{ rightModel.name }}</span> <span class="mr-sm-3">{{ quantity(rightModel) || '' }}</span>
                          </div>
                          <span class="product-dimensions text-left">{{ rightModel.dimensions }}</span>
                          <img
                            src="https://cdnew.visionnaire-home.com/{{rightModel.name.substring(0, 3)}}/{{rightModel.name}}.jpg"
                            alt="{{rightModel.name}}"/>
                          @if ((isLeftHookSelected || fullChainReached) && !added(rightModel)) {
                            <div class="disabled-layer" aria-hidden="true"></div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
                @case ('customize') {
                  <mat-tab-group
                    [selectedIndex]="cTabIndex"
                    class="tab-container"
                  >
                    @for (cTab of customizeTabs; track cTab) {
                      <mat-tab
                               [label]="cTab.label | translate"
                               class="tab flex-sb"
                               [disabled]="preventTabChange(cTab)"
                               [class.is-disabled]="preventTabChange(cTab)"
                      >
                        <ng-template matTabContent>
                          <div class="tab-content pt-4">
                            @switch (cTab.id) {
                              @case ('composition') {
                                <div class="customize-content">
                                  <div class="d-flex flex-row-space-around p-4">
                                    <label>{{ 'composition.customize-tab-all.type-upholstery' | translate}}</label>
                                    <mat-radio-group
                                      [(ngModel)]="upholsteryType">
                                      @for (uph of upholsteryTypes; track uph) {
                                        <mat-radio-button class="mx-2"  [value]="uph">
                                          {{uph}}
                                        </mat-radio-button>
                                      }
                                    </mat-radio-group>
                                  </div>
                                  <div>
                                    @if (upholsteryType === 'Rivestimento Separato') {
                                      <button class="btn width-100 btn-secondary fake-configuration-line flex-column text-left">
                                        <p>{{ 'components.composer.composer.seatUpholstery' | translate }}</p>
                                        <h2>{{ 'components.composer.composer.chalk' | translate }}</h2>
                                      </button>
                                    }
                                    @if (upholsteryType === 'Rivestimento Separato') {
                                      <button  class="btn width-100 btn-secondary fake-configuration-line flex-column text-left">
                                        <p>{{ 'components.composer.composer.backrestUpholstery' | translate }}</p>
                                        <h2>{{ 'components.composer.composer.chalk' | translate }}</h2>
                                      </button>
                                    }
                                    @if (upholsteryType === 'Rivestimento Unico') {
                                      <button class="btn width-100 btn-secondary fake-configuration-line flex-column text-left">
                                        <p>{{ 'components.composer.composer.mainUpholstery' | translate }}</p>
                                        <h2>{{ 'components.composer.composer.chalk' | translate }}</h2>
                                      </button>
                                    }
                                  </div>
                                </div>
                              }
                            }
                          </div>
                        </ng-template>
                      </mat-tab>
                    }
                  </mat-tab-group>
                }
                @case ('summary') {
                  <img src="assets/img/fake-summary.jpg" class="width-100" [alt]="'components.composer.composer.price' | translate">
                }
              }
            </div>
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
    <div class="footer" [class.is-visible]="!!composition.length"
         [class.is-hidden]="!composition.length">
      <button class="btn button-secondary" (click)="goToTab(0)">
        {{ 'components.composer.composer.modifica' | translate }}
      </button>
      <button *ngIf="tabIndex !==1" class="btn button-primary" (click)="goToTab(1)">
        {{ 'components.composer.composer.personalizza' | translate }}
      </button>
      <button *ngIf="tabIndex !==2" class="btn button-primary" (click)="goToTab(2)">
        {{ 'components.composer.composer.riepilogo' | translate }}
      </button>

    </div>
  </div>
</div>
